export enum ShopItemCurrencyType {
    USD = "USD",
    MON = "MON"
}
